module.exports = __webpack_public_path__ + "static/media/tala-hogt.22df651a.mp3";